var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnHamburger = function SvgIcnHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18 6H2a1 1 0 0 1 0-2h16a1 1 0 1 1 0 2m0 5H2a1 1 0 0 1 0-2h16a1 1 0 1 1 0 2m0 5H2a1 1 0 0 1 0-2h16a1 1 0 0 1 0 2"
  })));
};
export { SvgIcnHamburger as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIiBmaWxsPSJub25lIj48cGF0aCBkPSJNMTggNkgyYTEgMSAwIDAgMSAwLTJoMTZhMSAxIDAgMSAxIDAgMm0wIDVIMmExIDEgMCAwIDEgMC0yaDE2YTEgMSAwIDEgMSAwIDJtMCA1SDJhMSAxIDAgMCAxIDAtMmgxNmExIDEgMCAwIDEgMCAyIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";